import React from 'react'
import { DimmerLoader, Modal } from '../../../../views/components'
import styles from './ConfirmationActivationModal.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { agencyApiEvents } from '../../../api/agency'
import { apiStateSelectors } from '../../../api/apiState'

interface ConfirmationActivationModalProps {
  isOpen: boolean
  onClose: () => void
  agencyName: string
  agencyId: string
}

const ConfirmationActivationModal = ({
  isOpen,
  onClose,
  agencyName,
  agencyId,
}: ConfirmationActivationModalProps): React.ReactElement => {
  const dispatch = useDispatch()

  const isLoading = useSelector(state => apiStateSelectors.isLoading(state)([agencyApiEvents.activateAgency_request]))

  const handleConfirm = () => {
    dispatch(agencyApiEvents.activateAgency_request({ id: agencyId }))
    onClose()
  }

  return (
    <Modal className={styles.root} isOpen={isOpen} padding="sm" width="sm" theme="dark" showClose={false}>
      <Modal.Header title="Are you sure?" />
      <Modal.Body
        actions={[
          { label: 'Yes, activate', onClick: handleConfirm },
          { label: 'Cancel', onClick: onClose },
        ]}
      >
        <DimmerLoader loading={isLoading} bgColor="dark">
          <>
            <div className={styles['sub-header']}>You are about to activate {agencyName}</div>
          </>
        </DimmerLoader>
      </Modal.Body>
    </Modal>
  )
}

export default ConfirmationActivationModal
